import { create } from 'zustand'

import { getModelDetail, getToolDetail, getUserAi, patchUserAi, postModel } from '../api/assistant'
import {
    LLMModelDTO,
    LLMModelRestrictModel,
    LLMModelRestrictedUpsertOutputDTO,
    LlmModelDetailApiV1AiLlmModelLlmModelSlugGetParams,
    UserAIDefaultsDTO,
    UserAIDefaultsUpdateModel,
} from '../swagger/dto'

interface SettingState {
    userAi?: UserAIDefaultsDTO
    fetchUserAi: ({ data }: UserAIDefaultsUpdateModel) => Promise<UserAIDefaultsDTO>
    isLoadingFetchUserAi: boolean
    errorFetchUserAi?: string

    setIsDoneUpdateModel: (isDone: boolean) => void
    isDoneUpdateModel: boolean
    updateModel: (
        { data }: LLMModelRestrictModel,
        type: string,
    ) => Promise<LLMModelRestrictedUpsertOutputDTO>
    isLoadingUpdateModel: boolean
    errorUpdateModel?: string

    setIsDoneUpdateUserAi: (isDone: boolean) => void
    isDoneUpdateUserAi: boolean
    updateUserAi: ({ data }: UserAIDefaultsUpdateModel) => Promise<UserAIDefaultsDTO>
    isLoadingUpdateUserAi: boolean
    errorUpdateUserAi?: string

    toolDetail?: any[]
    fetchToolDetail: () => Promise<any>
    isLoadingFetchToolDetail: boolean
    errorFetchToolDetail?: string
    clearSetting: () => void
}
export const useSettingStore = create<SettingState>((set, get) => ({
    userAi: undefined,
    isLoadingFetchUserAi: false,
    errorFetchUserAi: undefined,
    fetchUserAi: async () => {
        try {
            set({
                userAi: undefined,
                isLoadingFetchUserAi: true,
                errorFetchUserAi: undefined,
            })
            const data = await getUserAi()

            set({
                userAi: data,
                isLoadingFetchUserAi: false,
            })
        } catch (error) {
            set({
                isLoadingFetchUserAi: false,
                errorFetchUserAi: 'Ошибка получения списка моделей',
            })
        }
    },

    setIsDoneUpdateUserAi: (isDone) => {
        set({
            isDoneUpdateUserAi: isDone,
        })
    },
    isDoneUpdateUserAi: false,
    isLoadingUpdateUserAi: false,
    errorUpdateUserAi: undefined,
    updateUserAi: async (data) => {
        try {
            set({
                isDoneUpdateUserAi: false,
                isLoadingUpdateUserAi: true,
                errorUpdateUserAi: undefined,
            })
            const response = await patchUserAi(data)

            set({
                isDoneUpdateUserAi: true,
                userAi: response,
                isLoadingUpdateUserAi: false,
            })
        } catch (error) {
            set({
                isLoadingUpdateUserAi: false,
                errorUpdateUserAi: 'Возникла ошибка',
            })
        }
    },

    isDoneUpdateModel: false,
    setIsDoneUpdateModel: (isDone) => {
        set({
            isDoneUpdateModel: isDone,
        })
    },

    isLoadingUpdateModel: false,
    errorUpdateModel: undefined,
    updateModel: async (data, type) => {
        try {
            set({
                isDoneUpdateModel: false,
                isLoadingUpdateModel: true,
                errorUpdateModel: undefined,
            })
            await postModel(data)

            set({
                isDoneUpdateModel: true,
                isLoadingUpdateModel: false,
            })
        } catch (error) {
            const errorText =
                error?.response?.data?.detail?.error_code ===
                'UnsupportedRestrictedLLMModelsCountError'
                    ? `Ошибка сохранения списка моделей. Выберите хотя бы одну модель для генерации ${type}.`
                    : 'Возникла ошибка'
            set({
                isLoadingUpdateModel: false,
                errorUpdateModel: errorText,
            })
        }
    },

    toolDetail: undefined,
    isLoadingFetchToolDetail: false,
    errorFetchToolDetail: undefined,
    fetchToolDetail: async () => {
        try {
            set({
                toolDetail: undefined,
                isLoadingFetchToolDetail: true,
                errorFetchToolDetail: undefined,
            })
            const data = await getToolDetail()

            set({
                toolDetail: data.objects,
                isLoadingFetchToolDetail: false,
            })
        } catch (error) {
            set({
                isLoadingFetchToolDetail: false,
                errorFetchToolDetail: 'Ошибка получения списка функций',
            })
        }
    },

}))
